var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 81,
    viewBox: "0 0 131 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M60.8569 48.1491L40.3582 64.1987L45.2267 46.1428L37.5397 42.8828L57.0135 27.0838L39.3333 9.78028L34.9774 24.8269L22.1657 38.6196H10.6352L9.86649 47.3967H6.27922C5.0493 48.3998 2.00864 48.985 0.64205 49.1522C-0.177897 49.3528 -0.0412393 39.7063 0.129583 34.8579L2.43568 32.6009V29.3408L3.46062 28.3377H11.9163L14.4787 25.5792V16.0497L15.5036 15.0466L23.9593 16.3005L39.8458 0L62.9068 24.3253L69.0564 20.5637L88.2739 43.8859L95.9609 43.1335L130.809 81.0008L93.9111 50.9076L87.249 52.4123L68.2877 29.8424L60.8569 48.1491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector17);
export default __webpack_public_path__ + "static/media/Vector 17.c3e00c239d6371580cb21a2fcf66c126.svg";
export { ForwardRef as ReactComponent };